import { render, staticRenderFns } from "./LidCard.vue?vue&type=template&id=3e06f1a0&scoped=true&"
import script from "./LidCard.vue?vue&type=script&lang=js&"
export * from "./LidCard.vue?vue&type=script&lang=js&"
import style0 from "./LidCard.vue?vue&type=style&index=0&id=3e06f1a0&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e06f1a0",
  null
  
)

export default component.exports